import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ErrorDetailColumn extends Component {
    render() {
        const {errorDetail} = this.props

        return <td className="error-detail">
            {
                errorDetail && errorDetail.length > 0 &&
                errorDetail.map(item => {
                    return <span className="error-item">{item}</span>
                })
            }
        </td>
    }
}

ErrorDetailColumn.propTypes = {
    errorDetail: PropTypes.number
}

export default ErrorDetailColumn